import { render, staticRenderFns } from "./EstablishmentTargetsPage.vue?vue&type=template&id=630628ca"
import script from "./EstablishmentTargetsPage.vue?vue&type=script&lang=js"
export * from "./EstablishmentTargetsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports